<script>
import Select from '@wielink-application/shared/vue/components/form/horizontal/select.vue'

export default Select;
</script>